import React from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import styles from './ChatBotComponent.module.css';
import MicOffIcon from '@mui/icons-material/MicOff';
import SettingsVoiceIcon from '@mui/icons-material/SettingsVoice';
import {IconButton} from '@mui/material';
import { callLogEvent } from '../../Common/Util';

export interface SpeechToTextProps {
    isDisable?: boolean;
    handleChange?: (event: any) => any;
}
const SpeechToText = ({ isDisable = false, handleChange }: SpeechToTextProps) => {
    const {
        transcript,
        finalTranscript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }

    const startListening = () => {
        SpeechRecognition.startListening();
        callLogEvent("CLICKED_ON_NEW_DAILOG_CHATBOX_MIC_ENABLE_BUTTON","Clicked to enable speech to text button");
    };

    const stopListening = () => {
        SpeechRecognition.stopListening();
        callLogEvent("CLICKED_ON_NEW_DAILOG_CHATBOX_MIC_DISABLE_BUTTON","Clicked to disable speech to text button");
    };
    const handleText = () => {
        handleChange && handleChange({ transcript, status: "in_progress" });
        if (transcript && finalTranscript && transcript.length === finalTranscript.length) {
            handleChange && handleChange({ transcript, status: "completed" });
            resetTranscript();
        }
    }

    transcript && handleText()
    // transcript && handleChange && handleChange({ transcript, finalTranscript });
    return (
        <IconButton
            size='small'
            disableRipple={isDisable}
            sx={{
                width: {xs: 34, sm: 38},
                height: {xs: 34, sm: 38},
                p: 0.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}
            onClick={
                listening
                    ? stopListening
                    : isDisable
                    ? resetTranscript
                    : startListening
            }
        >
            {listening ? (
                <SettingsVoiceIcon className={styles.disableMicBtn} />
            ) : (
                <MicOffIcon
                    className={isDisable ? styles.activeMicIcon : styles.disableMicBtn}
                />
            )}
        </IconButton>
    );
};

export default SpeechToText;
